import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Subsidiary } from '../../../../models/subsidiary';

@Injectable({
  providedIn: 'root'
})
export class SubsidiaryService {

  constructor(private _http: HttpClient) { }

  list(storeId: string, pageNumber?: number, pageSize?: number, name?: string) {
    pageNumber? pageNumber = pageNumber : pageNumber = 1
    pageSize? pageSize = pageSize : pageSize = 10
    name? name = name : name = ""
    return this._http.get(environment.url + `/management/subsidiary/store/${storeId}?pageNumber=${pageNumber}&pageSize=${pageSize}&name=${name}`);
  }

  get(storeId: string, id: string) {
    return this._http.get(environment.url + `/management/subsidiary/store/${storeId}/${id}`);
  }

  getDistrictsList() {
    return this._http.get(environment.url + `/management/subsidiary/districts`);
  }

  getDistrictCode(name): Observable<any> {
    return this._http.get(environment.url + `/management/subsidiary/districts/${name}`, {responseType: 'text'});
  }

  delete(storeId: string, id: string) {
    return this._http.delete(environment.url + `/management/subsidiary/store/${storeId}/${id}`);
  }

  update(subsidiary: Subsidiary) {
    return this._http.put(environment.url + `/management/subsidiary/store/${subsidiary.storeId}`, subsidiary);
  }

  create(subsidiary: Subsidiary) {
    return this._http.post(environment.url + `/management/subsidiary/store/${subsidiary.storeId}`, subsidiary);
  }

  upload(storeId: string, file: FormData) {
    return this._http.post(environment.url + `/management/subsidiary/store/${storeId}/upload`, file);
  }

  uploadToggleListSubsidiary(storeId: string, listSubisdiary: Subsidiary[]) {
    return this._http.put(environment.url + `/management/subsidiary/store/${storeId}/toggle-status`, listSubisdiary);
  }



}
